<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="w-full mb-5">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <div class="w-full" *ngIf="!exibirSpinnerPrincipal">
                <div class="flex align-items-center justify-content-between py-3">
                    <span class="text-xl font-semibold">{{ clienteSelecionado?.nome }}</span>

                    <div>
                        <button
                            *ngIf="saldoAtual > 0; else botaoTransfFalso"
                            pButton
                            pRipple
                            icon="pi pi-upload"
                            pTooltip="Realizar transferência de saldo"
                            tooltipPosition="left"
                            label="Transferir"
                            class="p-button-outlined"
                            (click)="abrirDialogTransferir()"
                        ></button>
                        <ng-template #botaoTransfFalso>
                            <button
                                pButton
                                pRipple
                                icon="pi pi-upload"
                                label="Transferir"
                                class="p-button-outlined"
                                disabled
                            ></button>
                        </ng-template>
                    </div>
                </div>
                <p-table
                    #tbPacotes
                    [value]="lancamentos"
                    dataKey="id"
                    [rows]="10"
                    [rowHover]="true"
                    [loading]="loading"
                    styleClass="p-datatable-gridlines"
                    [paginator]="true"
                    [globalFilterFields]="['descricao']"
                    responsiveLayout="stack"
                    styleClass=" p-datatable-sm"
                >
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between flex-column sm:flex-row">
                            <div class="flex">
                                <div class="p-fluid sm:mr-2">
                                    <label htmlFor="filtroData">Filtrar por Mês/Ano</label>
                                    <p-calendar
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true"
                                        [readonlyInput]="true"
                                        placeholder="Selecione"
                                        [(ngModel)]="filtroDataInicio"
                                        (ngModelChange)="carregarExtrato()"
                                        appendTo="body"
                                    ></p-calendar>
                                </div>
                                <div>
                                    <button
                                        *ngIf="filtroDataInicio"
                                        pButton
                                        pRipple
                                        [icon]="
                                            loadingRelatorio
                                                ? 'pi pi-spin pi-spinner'
                                                : 'pi pi-download'
                                        "
                                        pTooltip="Baixar extrato"
                                        class="p-button-primary mt-4 mr-2"
                                        [disabled]="
                                            lancamentos.length < 1 ||
                                            loadingRelatorio ||
                                            loadingRelatorioWhatsApp
                                        "
                                        (click)="obterRelatorioPdfExtratoContaAws()"
                                    ></button>
                                    <button
                                        *ngIf="filtroDataInicio"
                                        pButton
                                        pRipple
                                        pTooltip="Enviar WhatsApp"
                                        [icon]="
                                            loadingRelatorioWhatsApp
                                                ? 'pi pi-spin pi-spinner'
                                                : 'pi pi-whatsapp'
                                        "
                                        class="p-button-success mt-4"
                                        [disabled]="
                                            lancamentos.length < 1 ||
                                            loadingRelatorio ||
                                            loadingRelatorioWhatsApp
                                        "
                                        (click)="enviarMensagemWhatsAppAws()"
                                    ></button>
                                </div>
                            </div>
                            <div class="p-fluid mt-2 sm:mt-4">
                                <div class="flex">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input
                                            pInputText
                                            type="text"
                                            #filter
                                            (input)="buscar(tbPacotes, $event)"
                                            placeholder="Buscar"
                                            class="w-full"
                                        />
                                    </span>
                                    <span class="ml-2">
                                        <button
                                            pButton
                                            class="p-button-outlined"
                                            icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros"
                                            (click)="limpar(tbPacotes)"
                                        ></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="transacao">
                                Nº Transação
                                <p-sortIcon field="transacao"></p-sortIcon>
                            </th>
                            <th pSortableColumn="descricao">
                                Descrição
                                <p-sortIcon field="descricao"></p-sortIcon>
                            </th>
                            <th pSortableColumn="data">
                                Data
                                <p-sortIcon field="data"></p-sortIcon>
                            </th>
                            <th pSortableColumn="saldo">
                                Saldo
                                <p-sortIcon field="saldo"></p-sortIcon>
                            </th>
                            <th>Ações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                {{ item.transacao.toString().padStart(10, "0") }}
                            </td>
                            <td>
                                {{ item.descricao }}
                            </td>
                            <td>
                                {{ item.data | date: "dd/MM/yyyy" }}
                            </td>
                            <td>
                                {{ item.saldo | currency: "BRL" }}
                            </td>
                            <td>
                                <button
                                    pButton
                                    pRipple
                                    icon="pi pi-eye"
                                    (click)="abrirJanelaResumo(item)"
                                    class="p-button-info"
                                    pTooltip="Visualizar Transação"
                                ></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            <div>
                                <span *ngIf="extratoCliente">
                                    Saldo anterior:
                                    {{ extratoCliente.saldoAnterior | currency: "BRL" }}
                                </span>
                            </div>
                            <div>
                                <span *ngIf="extratoCliente">
                                    Saldo periodo:
                                    {{ extratoCliente.saldoPeriodo | currency: "BRL" }}
                                </span>
                            </div>
                            <div>
                                Saldo atual:
                                <span *ngIf="saldoAtual < 0" class="text-red-500">
                                    {{ saldoAtual | currency: "BRL" }}
                                </span>
                                <span *ngIf="saldoAtual >= 0">
                                    {{ saldoAtual | currency: "BRL" }}
                                </span>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="7">Carregando. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="formgroup" *ngIf="!exibirSpinnerPrincipal">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button
                            type="button"
                            pButton
                            class="p-button-outlined sm:w-9rem mt-5"
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            routerLink="/apps/central-cliente/conta"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog
        [(visible)]="exibirDialogTransferencia"
        [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
        [style]="{ width: '40rem' }"
        header="Transferência de Saldo"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        class="p-fluid"
        (onHide)="limparDadosDialogTransferencia()"
        (onShow)="focarInputValor()"
    >
        <div *ngIf="messagemVisivelDialog" class="w-full mb-5">
            <p-messages
                [(value)]="messagesDialog"
                [enableService]="false"
                [closable]="true"
            ></p-messages>
        </div>
        <ng-template pTemplate="content">
            <div class="field">
                <label for="name">Informe o CPF do Recebedor</label>
                <div class="flex flex-column md:flex-row gap-2">
                    <div class="flex-1" style="min-width: 0">
                        <p-inputMask
                            #cpfCliente
                            mask="999.999.999-99"
                            [unmask]="true"
                            type="text"
                            placeholder="000.000.000-00"
                            name="cpfCliente"
                            ngModel
                            [(ngModel)]="cpfClienteDigitado"
                        ></p-inputMask>
                    </div>
                    <button
                        pButton
                        pRipple
                        label="Buscar"
                        [icon]="loadingBuscarCliente ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
                        [disabled]="loadingBuscarCliente || cpfClienteDigitado.length === 0"
                        class="p-button-outlined w-full md:w-10rem"
                        (click)="buscarCliente()"
                    ></button>
                </div>
                <!-- <small class="ng-dirty ng-invalid" *ngIf="submitted && !product.name">
                    Name is required.
                </small> -->
            </div>

            <div class="formgrid grid" *ngIf="clienteParaTransferir">
                <div class="col-12">
                    <p-divider></p-divider>
                </div>
                <div class="field col-12 sm:col-7">
                    <label class="text-lg">Cliente</label>
                    <div class="flex flex-column">
                        <span>Nome: {{ clienteParaTransferir.nome }}</span>
                        <span>CPF: {{ clienteParaTransferir.cpf | cpfFormat }}</span>
                    </div>
                </div>
                <div class="field col-12 sm:col-5">
                    <label class="text-lg">Valor</label>
                    <p-inputNumber
                        name="valor"
                        ngModel
                        mode="currency"
                        inputId="valorTransf"
                        currency="BRL"
                        locale="pt-BR"
                        [allowEmpty]="true"
                        [required]="true"
                        [(ngModel)]="valorTransferencia"
                    ></p-inputNumber>
                </div>
                <div class="col-12">
                    <p-divider></p-divider>
                </div>
            </div>
            <div class="flex justify-content-start" *ngIf="clienteParaTransferir">
                <button
                    pButton
                    pRipple
                    label="Confirmar"
                    [icon]="loadingTransferir ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                    class="p-button-outlined w-full md:w-auto"
                    [disabled]="!clienteParaTransferir || loadingTransferir"
                    (click)="transferir()"
                ></button>
            </div>
        </ng-template>
    </p-dialog>
</div>
